import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {UserErrorsFactory} from '../../user/Errors/factory.js'
import UserServicesFactory from '../../user/Services/factory.js'
import UserFavoritesRepositoriesFactory from '../Repositories/factory.js'

class AddUserFavoriteDealerUseCase extends UseCase {
  #repository
  #userNotLoggedInError
  #getCurrentUserService

  constructor({repository, userNotLoggedInError, getCurrentUserService}) {
    super()
    this.#repository = repository
    this.#userNotLoggedInError = userNotLoggedInError
    this.#getCurrentUserService = getCurrentUserService
  }

  static create({config}) {
    return new AddUserFavoriteDealerUseCase({
      repository: UserFavoritesRepositoriesFactory.hTTPUserFavoritesRepository({
        config
      }),
      userNotLoggedInError: UserErrorsFactory.userNotLoggedInUserError,
      getCurrentUserService: UserServicesFactory.getCurrentUserService({
        config
      })
    })
  }

  @tracer({metric: 'AddUserFavoriteDealerUseCase#execute'})
  @AsyncInlineError()
  async execute({contractId} = {}) {
    if (!contractId) {
      throw new Error('[AddUserFavoriteDealerUseCase#execute] Missing contract id')
    }

    try {
      const userEntity = await this.#getCurrentUserService.execute()
      const userId = userEntity.getId()

      return this.#repository.addDealer({
        userId,
        contractId
      })
    } catch (error) {
      throw this.#userNotLoggedInError({
        message: '[AddUserFavoriteDealerUseCase#execute] User is not logged in'
      })
    }
  }
}

export const factory = AddUserFavoriteDealerUseCase.create
